import { ReactElement } from "react";
import styles from "./MobileCommentBoxPreservedSpace.module.less";

export const MobileCommentBoxPreservedSpace = (): ReactElement => {
	return (
		<div className={styles.root} />
	);
};
MobileCommentBoxPreservedSpace.displayName = "MobileCommentBoxPreservedSpace";